const GAP_THRESHOLD_MS = 30 * 60 * 1000;

/**
 * Returns a human-readable gap string if the time gap between two timestamps
 * exceeds 30 minutes. Returns null if no gap indicator should be shown.
 */
export function formatGap(timestampA: string, timestampB: string): string | null {
  const diff = Math.abs(new Date(timestampA).getTime() - new Date(timestampB).getTime());

  if (diff < GAP_THRESHOLD_MS) return null;

  const totalMinutes = Math.floor(diff / (60 * 1000));
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = totalMinutes % 60;

  if (days > 0 && hours > 0) return `${String(days)}d ${String(hours)}h gap`;
  if (days > 0) return `${String(days)}d gap`;
  if (hours > 0 && minutes > 0) return `${String(hours)}h ${String(minutes)}m gap`;
  if (hours > 0) return `${String(hours)}h gap`;
  return `${String(minutes)}m gap`;
}

export { GAP_THRESHOLD_MS };
